(() => {
  if (window.NonoPreorder) return;

  const style = document.createElement('style');
  style.textContent = `
    .nono-preorder-backdrop{position:fixed;inset:0;z-index:10000;background:rgba(0,0,0,.55);display:flex;align-items:center;justify-content:center;padding:12px}
    .nono-preorder-modal{box-sizing:border-box;width:min(520px,100%);background:#fff;border-radius:18px;padding:27px 28px 36px;color:#4b4b4b;box-shadow:0 18px 60px rgba(0,0,0,.28);font-family:inherit}
    .nono-preorder-modal h2{margin:0 0 12px;color:#416a60;font-size:22px;line-height:1.3;font-weight:700}
    .nono-preorder-modal p{margin:0 0 25px;font-size:16px;line-height:1.55}
    .nono-preorder-data{display:inline-block;margin-top:8px}
    .nono-preorder-data strong{color:#416a60;white-space:nowrap}
    .nono-preorder-actions{display:grid;grid-template-columns:1fr 1fr;gap:10px}
    .nono-preorder-actions button{min-height:45px;border-radius:999px;font:inherit;font-weight:500;cursor:pointer;padding:10px 18px}
    .nono-preorder-confirm{border:1px solid #d94c6c;background:#d94c6c;color:#fff}
    .nono-preorder-cancel{border:1px solid #ed9caf;background:#fff;color:#d94c6c}
    @media(max-width:520px){.nono-preorder-modal{padding:24px 28px 34px}.nono-preorder-actions{grid-template-columns:1fr}.nono-preorder-modal p{margin-bottom:22px}}
  `;
  document.head.appendChild(style);

  let resolving = false;

  /*
    Na ficha de produto NAO se pergunta a coleccao: o proprio tema ja calcula, a
    cada troca de variante, se a variante seleccionada e pre-venda, e escreve o
    resultado num `<div id="preorder-...">` escondido — vazio quando nao e.
    (Ver `can_show_preorder` em snippets/product-template.liquid e a lista de
    blocos re-desenhados em assets/variant-select.js.)

    Seguir esse marcador tem tres vantagens: acompanha a variante escolhida, nao
    duplica a regra do tema (que pode ser por coleccao OU por stock, conforme as
    definicoes), e nao gasta um pedido a rede.

    Devolve true/false quando ha marcador, e null quando nao ha — nas listagens
    esse bloco nao existe, e ai cai-se para a lista da coleccao mais abaixo.
  */
  // O tema ja decide a pre-venda por variante: ao mudar de variante volta a
  // desenhar `.properties_re_render-<seccao>`, e so escreve o marcador
  // `<input form="..." name="properties[Pre-venda]">` dentro de `#preorder-<seccao>`
  // quando a variante escolhida cumpre a regra das definicoes. Basta ler isso.
  //
  // A leitura e feita por `form.elements` e nao por ids: o marcador esta fora do
  // formulario e so lhe pertence pelo atributo `form`, e `form.elements` ja o
  // inclui. Comparar ids a mao falhava porque `form.id` NAO devolve o atributo
  // (o formulario tem um `<input name="id">` com a variante, e os controlos
  // tapam as propriedades do elemento) e porque ha varios formularios por
  // pagina: prestacoes, barra fixa, vista rapida e os complementares.
  function preVendaPeloTema(form) {
    const marcadores = document.querySelectorAll('[id^="preorder-"] input[name^="properties["]');
    const blocos = document.querySelectorAll('[id^="preorder-"]');
    if (!blocos.length) return null;
    if (!form || !form.elements) return marcadores.length > 0;

    const campos = Array.prototype.slice.call(form.elements);
    for (let n = 0; n < marcadores.length; n++) {
      if (campos.indexOf(marcadores[n]) !== -1) return true;
    }

    // A barra fixa submete um formulario proprio (`product-form-sticky-<seccao>`)
    // ao qual o marcador nunca se liga. Ai vale o bloco da mesma seccao.
    const idDoForm = form.getAttribute && form.getAttribute('id');
    const seccao = idDoForm && idDoForm.replace(/^product-form-(installment-|sticky-)?/, '');
    if (seccao) {
      const doMesmoBloco = document.getElementById('preorder-' + seccao);
      if (doMesmoBloco) return !!doMesmoBloco.querySelector('input[name^="properties["]');
    }
    return false;
  }

  // Nas listagens nao ha bloco `#preorder-...`, mas o cartao ja publica a mesma
  // decisao do tema em `x-labels-data` (ver "can_show_preorder" em
  // sections/card-product.liquid). Le-se dai em vez de ir buscar a coleccao
  // `pre-venda`: a regra do tema pode ser por coleccao OU por stock, e desde que
  // passou a ser por stock a coleccao dava respostas erradas.
  function preVendaPeloCartao(form) {
    if (!form || !form.closest) return null;
    const cartao = form.closest('.card-product, [class*="card-product"], li, .x-card-product');
    const dados = cartao && cartao.querySelector('.x-labels-data[x-labels-data]');
    if (!dados) return null;

    let lista;
    try {
      lista = JSON.parse(dados.getAttribute('x-labels-data'));
    } catch (erro) {
      return null;
    }
    if (!Array.isArray(lista) || !lista.length) return null;

    const variantId = String(new FormData(form).get('id') || '');
    const alvo = lista.find((v) => String(v.variant_id) === variantId) || lista[0];
    return alvo && typeof alvo.can_show_preorder === 'boolean' ? alvo.can_show_preorder : null;
  }


  function escapar(txt) {
    const d = document.createElement('div');
    d.textContent = txt == null ? '' : String(txt);
    return d.innerHTML;
  }

  // A data vem do badge que o tema ja escreve na pagina (metacampo custom.data_de_lancamento).
  // Procura-se dentro do bloco do proprio produto, para nao apanhar o badge de outro artigo
  // quando ha varios na pagina (listagens, vista rapida).
  function dataDeEnvio(form) {
    // Sem `form` nao se desiste: o `addToCart` nem sempre o consegue passar, e
    // era por isso que o aviso saia sem a data. Sem ele procura-se na pagina
    // toda, que na ficha de produto so tem um badge de data.
    const ambito =
      (form &&
        (form.closest('product-info, .product-info, .x-product-detail, .x-block-price, [id^="ProductInfo"]') ||
          form.closest('main'))) ||
      document;
    let el = ambito.querySelector('.data-lancamento-badge__data');
    if (!el) {
      const todos = document.querySelectorAll('.data-lancamento-badge__data');
      if (todos.length === 1) el = todos[0];
    }
    const txt = el && el.textContent.trim();
    return txt || null;
  }

  function showModal(dataEnvio) {
    return new Promise((resolve) => {
      if (resolving) return resolve(false);
      resolving = true;

      const backdrop = document.createElement('div');
      backdrop.className = 'nono-preorder-backdrop';
      backdrop.setAttribute('role', 'presentation');
      backdrop.innerHTML = `
        <section class="nono-preorder-modal" role="dialog" aria-modal="true" aria-labelledby="nono-preorder-title" aria-describedby="nono-preorder-text">
          <h2 id="nono-preorder-title">Aviso</h2>
          <p id="nono-preorder-text">Está a adicionar um produto em Pré-Venda, que ainda não está disponível para envio.${
            dataEnvio ? `<br><span class="nono-preorder-data">Envio previsto a partir de <strong>${escapar(dataEnvio)}</strong>.</span>` : ''
          }</p>
          <div class="nono-preorder-actions">
            <button type="button" class="nono-preorder-confirm">Sim, prosseguir</button>
            <button type="button" class="nono-preorder-cancel">Não, cancelar</button>
          </div>
        </section>
      `;

      const finish = (answer) => {
        document.removeEventListener('keydown', onKey);
        backdrop.remove();
        resolving = false;
        resolve(answer);
      };
      const onKey = (event) => {
        if (event.key === 'Escape') finish(false);
      };

      backdrop.querySelector('.nono-preorder-confirm').addEventListener('click', () => finish(true));
      backdrop.querySelector('.nono-preorder-cancel').addEventListener('click', () => finish(false));
      backdrop.addEventListener('click', (event) => {
        if (event.target === backdrop) finish(false);
      });
      document.addEventListener('keydown', onKey);
      document.body.appendChild(backdrop);
      backdrop.querySelector('.nono-preorder-confirm').focus();
    });
  }

  window.NonoPreorder = {
    async confirmVariant(form) {
      // O marcador do tema e verificado ANTES de olhar para o formulario: o
      // `addToCart` nem sempre consegue passar um (`$refs.product_form` pode vir
      // vazio), e com o `if (!form) return true` a fazer de porteiro o aviso
      // nunca chegava a ser mostrado na ficha de produto.
      // 1) Ficha de produto: o marcador do tema manda, e e por variante.
      const peloTema = preVendaPeloTema(form);
      if (peloTema !== null) {
        return peloTema ? await showModal(dataDeEnvio(form)) : true;
      }

      // 2) Listagens: nao ha marcador, le-se a decisao ja calculada no cartao.
      const peloCartao = preVendaPeloCartao(form);
      if (peloCartao) return await showModal(dataDeEnvio(form));
      return true;
    }
  };
})();